export const SYSTEM_MESSAGES = {
    CREATED: 'Profile has been successfully created',
    UPDATED: 'Profile has been successfully updated',
    ARCHIVED: 'User has been successfully archived',
    ARCHIVE_CONFIRM: 'Are you sure you want to archive this user?',
    BONUS_DEFINED: "The Bonus has been defined",
};

export const SNACK_TIMEOUT = 5000;
export const DEBOUNCE = 400;